import Vue from "vue";
import Vuex from "vuex";
import { vuexfireMutations } from "vuexfire";
import equipments from "./modules/equipments";
import events from "./modules/events";
import auth from "./modules/auth";
import repairs from "./modules/repairs";
import spareParts from "./modules/spareParts";
import recurringTasks from "./modules/recurringTasks";
import inspections from "./modules/inspections";
import reliabilities from "./modules/reliabilities";
import users from "./modules/users";
import works from "./modules/works";
import oneTimeTasks from "./modules/oneTimeTasks";
import assets from "./modules/assets";

import stocks from "./modules/stocks";
import calendar from "./modules/calendar";

import tickets from "./modules/tickets";
import settings from "./modules/settings";
import { db } from "@/plugins/db.js";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {},
  mutations: {
    ...vuexfireMutations
  },
  actions: {
    deleteNested: (context, payload) => {
      new Promise((resolve, reject) => {
        db
          .doc(payload.db)
          .delete()
          .then(() => {
            resolve();
          }),
          err => {
            reject(err);
          };
      });
    },
    //delete
    deleteDocument: async (context, payload) => {
      const res = await db
        .collection(payload.db)
        .doc(payload.doc)
        .delete();
      return res;
    },
    //update
    updateDocument: async (context, payload) => {
      const res = await db
        .collection(payload.db)
        .doc(payload.doc)
        .update(payload.data);
      return res;
    },
    updateNested: (context, payload) => {
      new Promise((resolve, reject) => {
        db
          .doc(payload.db)
          .update(payload.data)
          .then(() => {
            resolve();
          }),
          err => {
            reject(err);
          };
      });
    },
    addNested: (context, payload) => {
      new Promise((resolve, reject) => {
        db
          .collection(payload.db)
          .add(payload.data)
          .then(res => {
            const uid = res.id;
            let newPayload = {
              doc: res.id,
              db: payload.db,
              data: {
                id: res.id
              }
            };
            context
              .dispatch("updateDocument", newPayload)
              .then(() => {
                resolve(uid);
              })
              .catch(err => {
                reject(err);
              });
          })
          .catch(err => {
            reject(err);
          }),
          err => {
            reject(err);
          };
      });
    },
    //add
    addDocument: async (context, payload) => {
      const { id } = await db.collection(payload.db).add(payload.data);
      let newPayload = {
        doc: id,
        db: payload.db,
        data: {
          id: id
        }
      };

      await context.dispatch("updateDocument", newPayload);
      return id;
    }
  },
  getters: {},
  modules: {
    assets,
    auth,
    calendar,
    equipments,
    events,
    inspections,
    recurringTasks,
    reliabilities,
    repairs,
    settings,
    oneTimeTasks,
    spareParts,
    tickets,
    users,
    works,
    stocks
  }
});
